import React, {useEffect} from 'react'
import styles from './Main.module.scss'
import InitialPage from '../../components/initialPage/InitialPage'
import Callback from '../../components/Callback/Callback'
import Confidence from '../../components/Confidence/Confidence'
import AboutUs from '../../components/AboutUs/AboutUs'
import Popular from '../../components/Popular/Popular'
import VideoClip from '../../components/VideoClip/VideoClip'
import { arrPopular } from '../../utils/data'
import Offers from '../../components/Offers/Offers'

const Main = ({isOpen, popupOpen}) => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <section className={styles.main}>
            <InitialPage
                isOpen={isOpen}
            />
            <AboutUs/>
            <Offers/>
            <Confidence/>
            <VideoClip/>
            <Popular
                arr={arrPopular}
            />
            <Callback
                popupOpen={popupOpen}
            />  
        </section>
    )
}

export default Main